import React from 'react'

interface WithdrawSpeedProps {
  selectedLevel: number
  maxLevel: number
  className?: string
}

const ActiveSpeedIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_active)">
        <path
          d="M4.63791 6.91929H2.62541C2.36266 6.91929 2.18141 6.65629 2.27491 6.41091L4.27466 1.16191C4.30172 1.0909 4.34971 1.02978 4.41228 0.986649C4.47485 0.943521 4.54905 0.920422 4.62504 0.92041H7.99954C8.26579 0.92041 8.44729 1.19016 8.34679 1.43679L7.18241 4.29479H9.37441C9.69679 4.29479 9.86879 4.67479 9.65616 4.91704L4.28191 11.0408C4.02066 11.3385 3.53629 11.0805 3.63766 10.6977L4.63791 6.91929Z"
          fill="#22FD73"
        />
      </g>
      <defs>
        <clipPath id="clip0_active">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.0454102)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

const InactiveSpeedIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_inactive)">
        <path
          d="M4.63791 6.91929H2.62541C2.36266 6.91929 2.18141 6.65629 2.27491 6.41091L4.27466 1.16191C4.30172 1.0909 4.34971 1.02978 4.41228 0.986649C4.47485 0.943521 4.54905 0.920422 4.62504 0.92041H7.99954C8.26579 0.92041 8.44729 1.19016 8.34679 1.43679L7.18241 4.29479H9.37441C9.69679 4.29479 9.86879 4.67479 9.65616 4.91704L4.28191 11.0408C4.02066 11.3385 3.53629 11.0805 3.63766 10.6977L4.63791 6.91929Z"
          fill="#F9F9F9"
        />
      </g>
      <defs>
        <clipPath id="clip0_inactive">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.0454102)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

const WithdrawSpeed: React.FC<WithdrawSpeedProps> = ({
  selectedLevel,
  maxLevel,
  className = '',
}) => {
  // 生成速度等级数组
  const speedLevels = Array.from({ length: maxLevel }, (_, index) => index + 1)

  return (
    <div className={`flex items-center ${className}`}>
      {speedLevels.map(level => (
        <div key={level} className="flex items-center justify-center">
          {level > maxLevel - selectedLevel ? (
            <ActiveSpeedIcon />
          ) : (
            <InactiveSpeedIcon />
          )}
        </div>
      ))}
    </div>
  )
}

export default WithdrawSpeed
